export default "__VITE_ASSET__W7aY375n__"